import { useCallback, useEffect, useState } from 'react';
import { interfacesService, type IntegrationSummary, type InterfaceConnection } from '@/lib/interfacesService';

export function useInterfaceConnection(companyId: string | null) {
  const [connection, setConnection] = useState<InterfaceConnection | null>(null);
  const [integrations, setIntegrations] = useState<IntegrationSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    try {
      const [conn, ints] = await Promise.all([
        interfacesService.getConnection(companyId),
        interfacesService.listIntegrations(companyId),
      ]);
      setConnection(conn);
      setIntegrations(ints);
    } catch (e) {
      console.error('Failed to load interface connection:', e);
      setError('לא הצלחנו לטעון את הגדרות הממשקים');
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => { reload(); }, [reload]);

  return { connection, setConnection, integrations, loading, error, reload };
}
